import {
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
} from 'react-query';
import {
  CreateNotePayload,
  Note,
  NoteAPI,
  NoteSource,
  NoteSourceType,
  UpdateNotePayload,
} from 'api/note';

type AllNotesBySourceKeyType = ['notes', 'by-source', NoteSourceType, number];
export const AllNotesBySourceKey = (
  source: NoteSource,
): AllNotesBySourceKeyType => [
  'notes',
  'by-source',
  source.sourceType,
  source.sourceId,
];
export type GetAllNotesQueryOption = UseQueryOptions<
  Note[],
  unknown,
  Note[],
  AllNotesBySourceKeyType
>;
export const useGetAllNotesBySource = (
  source: NoteSource,
  options: GetAllNotesQueryOption = {},
): UseQueryResult<Note[], unknown> =>
  useQuery<Note[], unknown, Note[], AllNotesBySourceKeyType>(
    AllNotesBySourceKey(source),
    () => NoteAPI.getAllNotesBySource(source),
    options,
  );

export const useCreateNoteMutation = (
  options: UseMutationOptions<Note, unknown, CreateNotePayload> = {},
): UseMutationResult<Note, unknown, CreateNotePayload> =>
  useMutation<Note, unknown, CreateNotePayload>(
    (payload) => NoteAPI.createNote(payload),
    options,
  );

export const useUpdateNoteMutation = (
  options: UseMutationOptions<Note, unknown, UpdateNotePayload> = {},
): UseMutationResult<Note, unknown, UpdateNotePayload> =>
  useMutation<Note, unknown, UpdateNotePayload>(
    (payload) => NoteAPI.updateNote(payload),
    options,
  );
export const useDeleteNoteMutation = (
  options: UseMutationOptions<void, unknown, number> = {},
): UseMutationResult<void, unknown, number> =>
  useMutation<void, unknown, number>(
    (noteId) => NoteAPI.deleteNote(noteId),
    options,
  );
